export { ApplicationInsightsMonitoringService } from './lib/application-insights-monitoring.service';
export {
  APPLICATION_INSIGHTS_CONFIG,
  ApplicationInsightsConfig,
} from './lib/application-insights.model';
export { provideApplicationInsightsMonitoring } from './lib/provide-application-insights';
export { MonitoringService } from './lib/monitoring-service';
